import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useResetPasswordMutation } from "../../features/api/authApiSlice";
import "./auth.scss";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const res = await resetPassword({ token, password }).unwrap();
      setMessage(res?.message || "Password reset successful.");
      setPassword("");
    } catch (err) {
      setError(err?.data?.message || "Password reset failed");
    }
  };

  return (
    <main className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1>Reset Password</h1>
        <p>Create a new password for your account.</p>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        <label>
          New Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <button type="submit" disabled={isLoading}>
          {isLoading ? "Resetting..." : "Reset Password"}
        </button>

        {message && (
          <span>
            <Link to="/login">Go to Login</Link>
          </span>
        )}
      </form>
    </main>
  );
}
